// extracted by mini-css-extract-plugin
export default {"root":"NavList_root__kZKDG","item":"NavList_item__Ok3HL","noClick":"NavList_noClick__2mVoT"};